import styled from 'styled-components';

const ApplicationMsgWrap = styled.div`
    .ApplicationMsgWrap_title {
        font-size: 1.5rem;
        margin-bottom: 1rem;
    }

    .ApplicationMsgWrap_content {
        font-size: 1rem;
    }
`;
export default ApplicationMsgWrap;